import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { map, tap } from "rxjs/operators";
import { Observable } from "rxjs";

import { ProfileService } from "../api/profile.service";

export const HasWalletGuard: CanActivateFn = (route, state) => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  return profileService.getGeneral().pipe(
    map((response) => response.hasWallet),
    tap((hasWallet) => {
      if (!hasWallet) {
        router.navigate(["/no-wallet"]);
      }
    })
  ) as Observable<boolean>;
};
